import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c5fa59c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "main bg-fff m-t-8 flex-w-auto d-f flex-d-c" }
const _hoisted_3 = { class: "d-f justify-e" }
const _hoisted_4 = { class: "d-f" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Approve")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Reject")
const _hoisted_7 = { class: "table-wrapper flex-w-auto m-t-10" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Download Sample Check Form")
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_TableWrapper = _resolveComponent("TableWrapper")!
  const _component_approval_modal = _resolveComponent("approval-modal")!
  const _component_main_wrapper = _resolveComponent("main-wrapper")!

  return (_openBlock(), _createBlock(_component_main_wrapper, { className: "p-l-r-10" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, {
                class: "m-l-16",
                onClick: _ctx.approveClick
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                class: "m-l-16",
                onClick: _ctx.rejectClick
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TableWrapper, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  class: "tab-container default-self-table-text",
                  rowSelection: _ctx.rowSelection,
                  columns: _ctx.columnsData,
                  scroll: { x: '', y: _ctx.tableHeight},
                  pagination: false,
                  dataSource: _ctx.tableData,
                  rowKey: "payoutRoundId",
                  rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
                }, {
                  payoutRound: _withCtx(({ record }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(record.type === 'DEALER' ? 'link cursor-p' : ''),
                      onClick: ($event: any) => (_ctx.payoutRoundClick(record))
                    }, _toDisplayString(record.payoutRound), 11, _hoisted_8)
                  ]),
                  statusUpdateDate: _withCtx(({ record }) => [
                    _createElementVNode("span", null, _toDisplayString((typeof record.statusUpdateDate) === 'string' ? record.statusUpdateDate.substr(0, 10).replace(/\-/g, '/') : record.statusUpdateDate), 1)
                  ]),
                  operation: _withCtx(({ record }) => [
                    _createVNode(_component_a_tooltip, null, {
                      title: _withCtx(() => [
                        _hoisted_9
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "link cursor-p font_family icon-xiazai",
                          style: {"font-size":"24px"},
                          onClick: ($event: any) => (_ctx.downloadClick(record))
                        }, null, 8, _hoisted_10)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["rowSelection", "columns", "scroll", "dataSource", "rowClassName"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_component_approval_modal, {
        onOnConfirm: _ctx.confirmClick,
        visible: _ctx.approvalModalVisible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.approvalModalVisible) = $event)),
        list: _ctx.rowSelection.selectedRowData,
        approvalType: 'reject',
        "comments-required": true,
        formatkey: "payoutRound"
      }, null, 8, ["onOnConfirm", "visible", "list"])
    ]),
    _: 1
  }))
}